<template>
  <div class="oatManagement-container">
    <div class="top-filter">
      <el-form :model="queryInfo" size="medium" :inline="true">
        <el-form-item :label="$t('bike.name1')" prop="tenantId">
          <el-select v-model="queryInfo.tenantId" :placeholder="$t('public.name1')" clearable @change="handleChange">
            <el-option v-for="item in tenantIdOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
          <!-- <el-cascader ref="refHandle" v-model="tenantIds1"   :show-all-levels="false"  @change="handleChange" :props="{ lazy: true, lazyLoad: loadOptions,  checkStrictly: true }" clearable></el-cascader> -->
          </el-form-item>
        <el-form-item :label="$t('bike.name34')" prop="ebikeModelId">
          <el-select v-model="queryInfo.ebikeModelId" filterable :placeholder="$t('public.name1')" clearable>
            <el-option v-for="item in modelOptions" :key="item.ebikeModelId" :label="item.ebikeModelId" :value="item.ebikeModelId"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('bike.name20')" prop="firmwareType">
          <el-select v-model="queryInfo.firmwareType" :placeholder="$t('public.name1')" clearable>
            <el-option v-for="item in typeOptions" :key="item.name" :label="item.label" :value="item.name"> </el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item :label="$t('bike.name21')" prop="versionNumber">
          <el-input v-model="queryInfo.versionNumber" :placeholder="$t('public.name5')" class="input" clearable></el-input>
        </el-form-item> -->

        <el-form-item :label="$t('bike.name18')" prop="fileName">
          <el-input v-model="queryInfo.fileName" :placeholder="$t('public.name5')" class="input" clearable></el-input>
        </el-form-item>

        <el-form-item >
          <div class="bt-layout">
        <el-button type="primary" size="medium" @click="getPageList">{{$t('public.name3')}}</el-button>
        <el-button size="medium" @click="resetQuery">{{$t('public.name4')}}</el-button>
      </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="add-user">
        <el-button type="primary" icon="el-icon-plus" size="medium" @click="showAddDialog(null)"  v-if="buttonPerms.indexOf('bike/addOTA') > -1">{{ $t('operate.name11') }}</el-button>
      </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('bike.name22')" prop="id" sortable></el-table-column>
      <el-table-column :label="$t('bike.name5')" prop="tenantName" sortable>
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.parentName"> {{ scope.row.parentName  }}</span>
            <span v-if="scope.row.parentName">></span>
            <span v-if="scope. row.tenantName"> {{ scope. row.tenantName  }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name23')" prop="ebikeModelId" sortable v-if="userinfo.tenantType === 0 || userinfo.tenantType === 1"></el-table-column>
      <!-- <el-table-column :label="$t('bike.name24')" prop="versionNumber" sortable></el-table-column> -->
      <el-table-column :label="$t('bike.name25')" prop="fileName" sortable></el-table-column>
      <el-table-column :label="$t('bike.name26')" prop="firmwareType" sortable width="80">
        <template slot-scope="scope">
          <div>{{ ['IOT',$t('bike.name14'),$t('bike.name413')][scope.row.firmwareType] }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name27')" prop="fileSize" sortable width="80">
        <template slot-scope="scope">
          <div>{{ sizeExchange(scope.row.fileSize) }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name28')" prop="filePath" sortable width="328"></el-table-column>
      <el-table-column :label="$t('bike.name29')" prop="crtTime" sortable></el-table-column>
      <el-table-column :label="$t('bike.name11')" width="120px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="showAddDialog(scope.row)">{{$t('manage.name17')}}</el-button>
          <el-button type="text" @click="delList(scope.row)" style="color:#ea4646">{{$t('bike.name13')}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <el-dialog :title="type ===1 ?$t('bike.name448'):$t('bike.name449')" v-if="addDialog" :visible.sync="addDialog" :close-on-click-modal ="false" :before-close="close" width="460px">
      <el-form ref="otaFormRef" :model="otaInfo" label-width="120px"  :rules="otaInfoRules" style="width:100%;">
        <el-form-item prop="tenantId" :label="$t('bike.name1')"  >
          <el-select v-model="otaInfo.tenantId" :placeholder="$t('public.name1')" clearable style="width:100%;"  @change="handleChange1">
            <el-option v-for="item in tenantIdOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
          <!-- <el-cascader v-model="tenantIds2"   ref="refHandle" style="width:100%;" :show-all-levels="false" @change="handleChange1" :props="{ lazy: true, lazyLoad: loadOptions,  checkStrictly: true }" clearable></el-cascader> -->
        </el-form-item>
        <el-form-item prop="ebikeModelId" :label="$t('bike.name34')">
          <el-select style="width:100%;" v-model="otaInfo.ebikeModelId" filterable :placeholder="$t('public.name1')" clearable>
            <el-option v-for="item in modelOptions" :key="item.ebikeModelId" :label="item.ebikeModelId" :value="item.ebikeModelId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="firmwareType" :label="$t('bike.name20')">
          <el-select  style="width:100%;" v-model="otaInfo.firmwareType" :placeholder="$t('public.name1')" clearable>
            <el-option v-for="item in typeOptions" :key="item.name" :label="item.label" :value="item.name"> </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="版本号：" prop="versionNumber">
          <el-input v-model="otaInfo.versionNumber" :placeholder="$t('public.name5')" clearable></el-input>
        </el-form-item> -->
        <el-form-item prop="filePath" :label="$t('operate.name33')">
          <input v-model="otaInfo.filePath" style="display: none"   />
          <el-upload
            class="upload-demo"
            action=""
            :limit="1"
            :file-list="fileList"
            :on-remove="handleRemove"
            :http-request="
                (e) => {
                  handleUpLoadFile(e)
                }
              "
          >
            <el-button size="small" type="primary">{{ $t('operate.name34') }}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="type ===1 ?$t('bike.name448'):$t('bike.name449')" v-if="addDialog1" :visible.sync="addDialog1" :close-on-click-modal ="false" :before-close="close" width="460px">
      <el-form ref="otaFormRef" :model="otaInfo" label-width="120px"  :rules="otaInfoRules1" style="width:100%;">
        <el-form-item prop="ebikeModelId" :label="$t('bike.name34')">
          <el-select style="width:100%;" v-model="otaInfo.ebikeModelId" filterable :placeholder="$t('public.name1')" clearable>
            <el-option v-for="item in modelOptions" :key="item.ebikeModelId" :label="item.ebikeModelId" :value="item.ebikeModelId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="firmwareType" :label="$t('bike.name20')">
          <el-select  style="width:100%;" v-model="otaInfo.firmwareType" :placeholder="$t('public.name1')" clearable>
            <el-option v-for="item in typeOptions" :key="item.name" :label="item.label" :value="item.name"> </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="版本号：" prop="versionNumber">
          <el-input v-model="otaInfo.versionNumber" :placeholder="$t('public.name5')" clearable></el-input>
        </el-form-item> -->
        <el-form-item prop="filePath" :label="$t('operate.name33')">
          <input v-model="otaInfo.filePath" style="display: none"   />
          <el-upload
            class="upload-demo"
            action=""
            :limit="1"
            :file-list="fileList"
            :on-remove="handleRemove"
            :http-request="
                (e) => {
                  handleUpLoadFile(e)
                }
              "
          >
            <el-button size="small" type="primary">{{ $t('operate.name34') }}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="type ===1 ?$t('bike.name448'):$t('bike.name449')" v-if="addDialog2" :visible.sync="addDialog2" :close-on-click-modal ="false" :before-close="close" width="460px">
      <el-form ref="otaFormRef" :model="otaInfo" label-width="120px"  :rules="otaInfoRules2">
        <el-form-item prop="firmwareType" :label="$t('bike.name20')">
          <el-select  style="width:100%;" v-model="otaInfo.firmwareType" :placeholder="$t('public.name1')">
            <el-option v-for="item in typeOptions" :key="item.name" :label="item.label" :value="item.name"> </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="版本号：" prop="versionNumber">
          <el-input v-model="otaInfo.versionNumber" :placeholder="$t('public.name5')"></el-input>
        </el-form-item> -->
        <el-form-item prop="filePath" :label="$t('operate.name33')">
          <input v-model="otaInfo.filePath" style="display: none"   />
          <el-upload
            class="upload-demo"
            action=""
            :limit="1"
            :file-list="fileList"
            :on-remove="handleRemove"
            :http-request="
                (e) => {
                  handleUpLoadFile(e)
                }
              "
          >
            <el-button size="small" type="primary">{{ $t('operate.name34') }}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { findOtaFirmwarePage, findEbikeModelPage, queryIotEbikeModelList, saveFirmwareInfo, modifyFirmwareInfo, removeFirmwareInfo, otaFirmwareInfoList1, otaFirmwareInfoList2, otaFirmwareInfoList3 } from '@/api/bike.js'
import { uploadFile, tenantList } from '@/api/manage.js'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      buttonPerms: '',
      tenantIds1: [],
      tenantIds2: [],
      tenantIdOptions: [],
      queryInfo: {
        pageNumber: 1,
        pageSize: 10,
        tenantId: '',
        fileName: '',
        firmwareType: '',
        // versionNumber: '',
        ebikeModelId: ''
      },
      total: 0,
      fileList: [],
      modelOptions: [],
      tenantOptions: [],
      tableList: [],
      addDialog2: false,
      tableLoading: false,
      addDialog: false,
      addDialog1: false,
      loading: false,
      versionOPtions: [],
      typeOptions: [
        { name: 0, label: 'IOT' },
        { name: 1, label: this.$t('bike.name14') },
        { name: 2, label: this.$t('bike.name413') }
      ],
      otaInfo: {
        filePath: '',
        fileName: '',
        fileSize: '',
        firmwareType: '',
        // versionNumber: '',
        tenantId: '',
        ebikeModelId: ''
      },
      type: 1,
      otaInfoRules: {
        // versionNumber: [
        //   {
        //     required: true,
        //     message: '请输入版本号',
        //     trigger: 'blur'
        //   }
        // ],
        ebikeModelId: [
          {
            required: true,
            message: this.$t('bike.name480'),
            trigger: 'blur'
          }
        ],
        tenantId: [
          {
            required: true,
            message: this.$t('bike.name481'),
            trigger: 'blur'
          }
        ],
        filePath: [
          {
            required: true,
            message: this.$t('bike.name482'),
            trigger: 'blur'
          }
        ],
        firmwareType: [
          {
            required: true,
            message: this.$t('bike.name471'),
            trigger: 'blur'
          }
        ]
      },
      otaInfoRules1: {
        // versionNumber: [
        //   {
        //     required: true,
        //     message: '请输入版本号',
        //     trigger: 'blur'
        //   }
        // ],
        ebikeModelId: [
          {
            required: true,
            message: this.$t('bike.name480'),
            trigger: 'blur'
          }
        ],
        filePath: [
          {
            required: true,
            message: this.$t('bike.name482'),
            trigger: 'blur'
          }
        ],
        firmwareType: [
          {
            required: true,
            message: this.$t('bike.name471'),
            trigger: 'blur'
          }
        ]
      },
      otaInfoRules2: {
        // versionNumber: [
        //   {
        //     required: true,
        //     message: '请输入版本号',
        //     trigger: 'blur'
        //   }
        // ],
        filePath: [
          {
            required: true,
            message: this.$t('bike.name482'),
            trigger: 'blur'
          }
        ],
        firmwareType: [
          {
            required: true,
            message: this.$t('bike.name471'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  components: {},
  created() {
    this.buttonPerms = localStorage.getItem('buttonPerms')
    // this.otaInfo.tenantId = this.userinfo.tenantId
    this.loadOptions()
  },
  mounted() {
    this.getListData()
    // this.getOtaFirmwareInfoLlist1()
    // this.getEbikeModelList()
  },
  destroyed() {},
  methods: {
    resetQuery() {
      this.queryInfo = {
        pageNumber: 1,
        pageSize: 10,
        tenantId: '',
        fileName: '',
        firmwareType: '',
        // versionNumber: '',
        ebikeModelId: ''
      }
      this.tenantIds1 = []
      this.getListData()
    },
    getEbikeModelList() {
      const queryInfo = {
        pageNumber: 1,
        pageSize: 500
      }
      findEbikeModelPage(queryInfo).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.modelOptions = res.data.ebikeModelPage.records
        }
      })
    },
    getPageList() {
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      this.getListData()
    },
    getListData() {
      this.tableLoading = true
      // this.queryInfo.versionNumber = this.queryInfo.versionNumber.trim()
      this.queryInfo.fileName = this.queryInfo.fileName.trim()
      findOtaFirmwarePage(this.queryInfo)
        .then(res => {
          this.tableList = res.data.page.records
          this.total = res.data.page.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
          this.tableList = []
          this.total = 0
        })
    },
    getModelList(tenantId) {
      const data = {
        tenantId: tenantId
      }
      queryIotEbikeModelList(data)
        .then(res => {
          this.modelOptions = res.data
        })
        .catch(() => {
          this.modelOptions = []
        })
    },
    getOtaFirmwareInfoLlist1() {
      otaFirmwareInfoList1()
        .then(res => {
          this.tenantOptions = res.data
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    handleUpLoadFile(param) {
      this.fileList = []
      const formData = new FormData()
      formData.append('multipart', param.file)
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name35'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      uploadFile(formData)
        .then(res => {
          loading.close()
          if (res.code === 200) {
            this.otaInfo.filePath = res.data.fileUrl
            this.otaInfo.fileName = res.data.fileName
            this.otaInfo.fileSize = res.data.fileSize
            this.fileList = [{ name: res.data.fileName, url: res.data.fileUrl }]
            this.$message.success(this.$t('public.name42'))
          }
        })
        .catch(res => {
          this.fileList = []
          loading.close()
        })
    },
    handleChange(value) {
      // 处理选项变化
      this.queryInfo.tenantId = value
      this.getModelList(this.queryInfo.tenantId)
    },
    handleChange1(value) {
      // 处理选项变化
      this.otaInfo.tenantId = value
      this.otaInfo.ebikeModelId = ''
      this.getModelList(value)
    },
    // handleChangeTenant(value) {
    //   this.otaInfo.tenantId = value
    //   this.getOtaFirmwareInfoLlist2(value)
    // },
    loadOptions() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName
            }))
            this.tenantIdOptions = options
            this.otaInfo.tenantId = this.tenantIdOptions[0].value
            this.handleChange1(this.otaInfo.tenantId)
          } else {
            this.tenantIdOptions = []
          }
        })
        .catch(() => {})
    },
    getOtaFirmwareInfoLlist2() {
      const data = {
        tenantId: this.otaInfo.tenantId
      }
      otaFirmwareInfoList2(data)
        .then((res) => {
          res.data.map((item) => {
            this.typeAllOptions.map((items) => {
              if (item === items.name) {
                const obj = {}
                obj.name = items.name
                obj.label = items.label
                this.typeOptions.push(obj)
              }
            })
          })
        })
        .catch(() => {
          this.typeOptions = []
        })
    },
    changeType(e) {
      const data = {
        tenantId: this.otaInfo.tenantId,
        firmwareType: e
      }
      otaFirmwareInfoList3(data)
        .then((res) => {
          this.versionOPtions = res.data
        })
        .catch(() => {
          this.versionOPtions = []
        })
    },
    submitForm() {
      this.$refs.otaFormRef.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        // this.otaInfo.versionNumber = this.otaInfo.versionNumber.trim()
        if (this.type === 1) {
          saveFirmwareInfo(this.otaInfo)
            .then((res) => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.queryInfo.tenantId = ''
                this.queryInfo.pageNumber = 1
                this.getListData()
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          modifyFirmwareInfo(this.otaInfo).then((res) => {
            this.loading = false
            if (res.code === 200) {
              this.close()
              this.queryInfo.pageNumber = 1
              this.getListData()
            }
          }).catch(() => {
            this.loading = false
          })
        }
      })
    },
    close() {
      this.otaInfo = {
        filePath: '',
        fileName: '',
        fileSize: '',
        firmwareType: '',
        versionNumber: '',
        ebikeModelId: '',
        tenantId: this.tenantIdOptions[0].value
      }
      this.handleChange1(this.otaInfo.tenantId)
      this.tenantIds2 = []
      this.fileList = []
      this.addDialog = false
      this.addDialog1 = false
      this.addDialog2 = false
    },
    showAddDialog(row) {
      if (row === null) {
        this.type = 1
      } else {
        this.type = 2
        this.fileList = [{ name: row.fileName, url: row.filePath }]
        this.otaInfo = {
          filePath: row.filePath,
          fileName: row.fileName,
          fileSize: row.fileSize,
          firmwareType: row.firmwareType,
          versionNumber: row.versionNumber,
          tenantId: [],
          ebikeModelId: row.ebikeModelId,
          id: row.id
        }
        if (row.parentId) {
          this.otaInfo.tenantId = [row.parentId, row.tenantId]
          this.tenantIds2 = [row.parentId, row.tenantId]
        } else {
          this.otaInfo.tenantId = [row.tenantId]
          this.tenantIds2 = [row.tenantId]
        }
      }
      if (this.userinfo.tenantType === 0 || this.userinfo.tenantType === 1) {
        this.addDialog = true
      } else if (this.userinfo.tenantType === 22) {
        this.addDialog2 = true
      }
      // if (this.userinfo.tenantType === 0) {
      //   this.addDialog = true
      // } else if (this.userinfo.tenantType === 1) {
      //   this.otaInfo.tenantId = []
      //   this.otaInfo.tenantId.push(this.userinfo.tenantId)
      //   this.addDialog1 = true
      // } else if (this.userinfo.tenantType === 22) {
      //   this.addDialog2 = true
      // }
    },
    delList(row) {
      this.$confirm(this.$t('public.name40'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          removeFirmwareInfo({ id: row.id })
            .then(res => {
              if (res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$t('public.name30')
                })
                this.queryInfo.pageNumber = 1
                this.getListData()
              }
            })
            .catch(() => {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    handleRemove(file, fileList) {
      this.otaInfo.filePath = ''
      this.fileList = []
    },
    sizeExchange(size) {
      let data = ''
      const _size = Number.parseFloat(size)
      if (_size < 1 * 1024) {
        data = _size.toFixed(1) + 'B'
      } else if (_size < 1 * 1024 * 1024) {
        data = (_size / 1024).toFixed(1) + 'KB'
      } else if (_size < 1 * 1024 * 1024 * 1024) {
        data = (_size / (1024 * 1024)).toFixed(1) + 'MB'
      } else {
        data = (_size / (1024 * 1024 * 1024)).toFixed(1) + 'GB'
      }
      const sizeStr = data + ''
      const len = sizeStr.indexOf('.')
      const dec = sizeStr.substr(len + 1, 2)
      if (dec === '00') {
        return sizeStr.substring(0, len) + sizeStr.substr(len + 3, 2)
      }
      return sizeStr
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getListData()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.getListData()
    }
  }
}
</script>
<style lang="scss" scoped>
.oatManagement-container {
  display: flex;
  flex-direction: column;

  .top-filter {
    display: flex;
    justify-content: space-between;
  }
  .input {
    width: px2vw(147);
  }
  .form-item2 {
    margin-left: px2vw(-15);
  }
  .bt-layout{
    display: flex;
    flex-direction: row;
    height: 36px;
  }
}
</style>
